import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Flex, Box } from 'grid-styled';

import Input from 'components/Input/Input';
import RadioGroup from 'components/RadioGroup/RadioGroup';
import LoginView from 'components/LoginView/LoginView';
import Button from 'components/Button/Button';
import P from 'components/P/P';

import messages from './messages';
import { isEmailValid } from '../../utils/email';

@inject('authStore')
@observer
class SignupView extends React.Component {
  state = {
    username: '',
    firstname: '',
    lastname: '',
    experience: '',
    type: 'bachelor',
    signupCreated: false,
    error: null
  };

  async handleSubmit(event) {
    event.preventDefault();
    const { authStore } = this.props;
    const { username, firstname, lastname, experience, type } = this.state;
    this.setState({ error: null });
    const response = await authStore.signup({
      email: username.toLowerCase(),
      firstname,
      lastname,
      experience,
      type
    });

    if (response.error) {
      this.setState({ error: response.error.message });
    } else {
      this.setState({ signupCreated: true });
    }
  }
  updateFirstName(event) {
    this.setState({ firstname: event.target.value });
  }
  updateLastName(event) {
    this.setState({ lastname: event.target.value });
  }
  updateUsername(event) {
    this.setState({
      username: event.target.value
    });
  }
  handleType(value) {
    this.setState({ type: value });
  }
  updateExperience(event) {
    this.setState({ experience: event.target.value });
  }

  render() {
    const {
      username,
      firstname,
      lastname,
      type,
      experience,
      error,
      signupCreated,
      firstnameError,
      lastnameError,
      usernameError,
      experienceError
    } = this.state;
    const { intl: { formatMessage } } = this.props;
    const title = formatMessage(messages.signupTitle);
    const message = formatMessage(messages.signupMessage);

    const isValid =
      username && firstname && lastname && experience && isEmailValid(username);

    return (
      <LoginView title={title} message={signupCreated ? '' : message}>
        {signupCreated && (
          <Box mb={10}>
            <P>
              <FormattedMessage {...messages.signupSuccessMessage} />
            </P>
          </Box>
        )}
        {!signupCreated && (
          <form onSubmit={e => this.handleSubmit(e)}>
            {error && (
              <Box mb={10}>
                <P danger>{error}</P>
              </Box>
            )}

            <Box mb={20}>
              <Input
                name="firstname"
                onChange={e => this.updateFirstName(e)}
                placeholder={formatMessage(messages.signupFirstName)}
                value={firstname}
                type="text"
                onBlur={() => this.setState({ firstnameError: !firstname })}
                error={firstnameError}
              />
            </Box>
            <Box mb={20}>
              <Input
                name="lastname"
                onChange={e => this.updateLastName(e)}
                placeholder={formatMessage(messages.signupLastName)}
                value={lastname}
                type="text"
                onBlur={() => this.setState({ lastnameError: !lastname })}
                error={lastnameError}
              />
            </Box>
            <Box mb={20}>
              <Input
                name="username"
                placeholder={formatMessage(messages.signupUsername)}
                onChange={e => this.updateUsername(e)}
                value={username}
                onBlur={() =>
                  this.setState({
                    usernameError: !username || !isEmailValid(username)
                  })
                }
                type="text"
                error={usernameError}
              />
            </Box>
            {/*<Box mb={20}>
            <Input
              name="password"
              onChange={e => this.updatePassword(e)}
              placeholder={formatMessage(messages.signupPassword)}
              value={password}
              type="password"
              error={passwordError}
            />
          </Box>*/}
            <Flex flexWrap="wrap">
              <Box width={[1 / 1, 1 / 1, 1 / 2]} mb={2}>
                <Input
                  name="experience"
                  type="text"
                  onChange={e => this.updateExperience(e)}
                  placeholder={formatMessage(messages.loginExperience)}
                  value={experience}
                  onBlur={() => this.setState({ experienceError: !experience })}
                  error={experienceError}
                />
              </Box>
              <Box width={[1 / 1, 1 / 1, 1 / 2]} pl={[0, 0, 2]} mb={2} pt={1}>
                <RadioGroup
                  name="type"
                  active={type}
                  items={[
                    {
                      label: 'bachelor diploma',
                      value: 'bachelor'
                    },
                    {
                      label: 'master diploma',
                      value: 'master'
                    }
                  ]}
                  onChange={value => this.handleType(value)}
                />
              </Box>
            </Flex>
            <Button disabled={!isValid} secondary>
              <FormattedMessage {...messages.signupSubmitButton} />
            </Button>
          </form>
        )}
      </LoginView>
    );
  }
}

export default injectIntl(SignupView);



// WEBPACK FOOTER //
// ./src/containers/login/SignupView.js